import { useGetWidgetSettingsListWidgetSettingsListGetQuery } from '@shared/api';
import { Routes, buildOrganizationRoute } from '@shared/constants/routes';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Select, type SelectProps } from 'antd';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type PresetSelectorProps = Omit<SelectProps<number>, 'loading' | 'options'>;

export const PresetSelector: FC<PresetSelectorProps> = (props) => {
  const { t } = useTranslation('translation', { keyPrefix: 'channels.form' });
  const navigate = useNavigate();
  const organizationId = useAppSelector(authSelectors.selectCurrentOrganizationId);
  const { data: presets = [], isLoading } = useGetWidgetSettingsListWidgetSettingsListGetQuery(
    { organizationId: organizationId ?? 0 },
    { skip: !organizationId },
  );

  const options = useMemo(
    () => presets.map((preset) => ({ label: preset.name, value: preset.id })),
    [presets],
  );

  const handleCreatePreset = () => {
    navigate(
      organizationId
        ? buildOrganizationRoute(Routes.organizationScope.presetsCreate, organizationId)
        : Routes.presets.create,
    );
  };

  return (
    <Select
      {...props}
      allowClear
      showSearch
      optionFilterProp="label"
      loading={isLoading}
      options={options}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <Button
            type="text"
            block
            icon={<PlusOutlined />}
            onMouseDown={(event) => event.preventDefault()}
            onClick={handleCreatePreset}
            style={{ justifyContent: 'flex-start' }}
          >
            {t('createPreset')}
          </Button>
        </>
      )}
    />
  );
};
